import { navBarShouldBeVisible } from "./noNavBarRoutes";
import AccessDenied from "components/AccessDenied";
import Admin from "components/Admin";
import Calculators from "components/Calculators";
import CashflowsPage from "components/CashflowsPage";
import ChangePassword from "components/ChangePassword";
import Deal from "components/Deal";
import ProjectionsPage from "components/Deal/Projections/ProjectionsPage";
import NewPipelineDeal from "components/DealPipelineForm";
import ForgotPassword from "components/ForgotPassword";
import FundDealsList from "components/Fund/Deals";
import GuestCompanyLanding from "components/GuestView/GuestCompanyLanding";
import GuestLanding from "components/GuestView/GuestLanding";
import HedgeDetailPage from "components/HedgeDetailPage";
import HedgeEscrowLedger from "components/HedgeEscrowLedger/HedgeEscrowLedger";
import Home from "components/Home";
import LoadingIndicator from "components/LoadingIndicator";
import NewLoan from "components/Loan";
import LoanDetailsPage from "components/LoanDetailsPage";
import Login from "components/Login";
import Logout from "components/Logout";
import NoMatch from "components/NoMatch";
import Notes from "components/Notes";
import Notifications from "components/Notifications";
import Pipeline from "components/Pipeline";
import PipelineActiveDeal from "components/Pipeline/ActiveDeal/PipelineActiveDeal";
import QuoteComparison from "components/Pipeline/QuoteComparisonPage/QuoteComparison";
import Portfolio from "components/Portfolio";
import PrivateRoute from "components/PrivateRoute";
import Properties from "components/Properties";
import Reports from "components/Reports";
import NewReports from "pages/newReports";
import TopNavigation from "components/TopNavigation";
import ResetPass from "components/User/ResetPass";
import PoliciesAndAgreements from "components/User/PoliciesAndAgreements";
import PrepaymentSnapshot from "pages/campaigns/templates/PrepaymentSnapshot";
import { ValuationSensitivitySnapshot } from "pages/campaigns/templates/";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import featureFlags from "constants/featureFlags";
import { compose } from "redux";

import {
  CASHFLOWS_PAGE,
  HEDGE_DETAILS,
  HEDGE_ESCROWS_LEDGER,
  NOTIFICATIONS_PAGE,
  PIPELINE_DEAL_QUOTE_COMPARISON,
  REPORTS,
  NEW_REPORTS,
  ROUTE_ADMIN,
  ROUTE_ADMIN_LOGIN,
  ROUTE_APP_LANDING,
  ROUTE_CALCULATORS,
  ROUTE_CHANGE_PASSWORD,

  // new
  ROUTE_DASHBOARD,
  ROUTE_BROKER_DASHBOARD,
  ROUTE_DEAL,
  ROUTE_DEAL_LITE,
  ROUTE_DEALS_DETAILS,
  ROUTE_DEAL_ANALYSIS,
  ROUTE_DEAL_DETAIL_EDIT,
  ROUTE_DEAL_LOAN_EDIT,
  ROUTE_DEAL_LOAN_NEW,
  ROUTE_DEAL_LOAN_VIEW,
  ROUTE_DEAL_NEW,
  ROUTE_DEAL_PROJECTIONS,
  ROUTE_DEAL_QUOTE_VIEW,
  ROUTE_DEAL_SETTINGS,
  ROUTE_FORGOT_PASSWORD,
  ROUTE_FUNDS_DETAIL,
  ROUTE_GUEST_COMPANY_LANDING,
  ROUTE_GUEST_LANDING,
  ROUTE_HEDGE_DETAIL,
  ROUTE_HEDGE_DETAIL_EDIT,
  ROUTE_LENDER_REPORTS_SETUP,
  ROUTE_LENDER_REPORTS_NOI_SETUP,
  ROUTE_LENDER_REPORTS_PROJECTED_NOI_SETUP,
  ROUTE_LENDER_REPORTS_DSCR_SETUP,
  ROUTE_LENDER_REPORTS_PROJECTED_DSCR_SETUP,
  ROUTE_LENDER_REPORTS_DEBT_YIELD_SETUP,
  ROUTE_LENDER_REPORTS_PROJECTED_DEBT_YIELD_SETUP,
  ROUTE_LENDER_REPORTS_PREVIEW,
  ROUTE_LOAN_DETAIL,
  ROUTE_LOAN_DETAILS_PAGE,
  ROUTE_LOAN_DETAIL_EDIT,
  ROUTE_LOGIN,
  ROUTE_LOGOUT,
  ROUTE_PIPELINE,
  ROUTE_PIPELINE_ACTIVE,
  ROUTE_PIPELINE_ACTIVE_DEAL,
  ROUTE_PIPELINE_ARCHIVED,
  ROUTE_PIPELINE_DEAD,
  ROUTE_PIPELINE_SOFT_QUOTES,
  ROUTE_PORTFOLIO,
  ROUTE_PROPERTIES,
  ROUTE_PROPERTY_DETAIL,
  ROUTE_PROPERTY_DETAIL_EDIT,
  ROUTE_QUOTES_BY_DEAL,
  ROUTE_QUOTE_DETAIL,
  ROUTE_QUOTE_HISTORY,
  ROUTE_USERS_CHANGE_PASS,
  ROUTE_LENDER_REPORTS,
  ROUTE_LENDER_REPORT_DETAILS,
  ROUTE_LENDER_REPORTS_COMPONENTS_NOI_CALC,
  ROUTE_LENDER_REPORTS_COMPONENTS_DSCR_CALC,
  ROUTE_LENDER_REPORTS_COMPONENTS_DY_CALC,
  ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_NOI_CALC,
  ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_DSCR_CALC,
  ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_DY_CALC,
  SREO_SCREENER,
  POLICIES_AND_AGREEMENTS,
  ROUTE_REFI_PROCEEDS_ANALYSIS_UNSUPERVISED,
  ROUTE_REFI_PROCEEDS_ANALYSIS_SUPERVISED,
  ROUTE_DEAL_SCREENER,
  ROUTE_DEAL_SCREENER_EDC,
  ROUTE_CAMPAIGNS,
  ROUTE_INDIVIDUAL_CAMPAIGN,
  ROUTE_EMAIL_DRAFT,
  ROUTE_EDC_MASTER_CONTACT_LIST,
  ROUTE_APPS,
  DEBT_VALUATION_SETUP,
  DEBT_VALUATION_DASHBOARD,
  DEBT_VALUATION_SPREADS,
  LENDER_REPORTING_DASHBOARD,
  LENDER_REPORTING_SETTINGS,
  LENDER_REPORTING_LENDER_VIEW,
  LENDER_REPORTING_TASK_VIEW,
  LENDER_REPORTING_SUBMITTED,
  REFI_BREAKEVEN_VIEW,
  PREPAYMENT_SNAPSHOT_VIEW,
  VALUATION_SENSITIVITY_SNAPSHOT_VIEW,
  REFI_CASHOUT_VIEW,
  ROUTE_ONBOARDING_VIEW
} from "constants/routes";
import "material-icons-font/material-icons-font.css";
import numeral from "numeral";
// NEW
import Dashboard from "pages/dashboard/Dashboard";
import BrokerDashboard from "pages/brokerDashboard/BrokerDashboard";
import { default as NewDeal } from "pages/deal/deal";
import { default as DealLite } from "pages/deal/dealLite/DealLiteWrapper";
import { default as DealAnalysis } from "pages/dealAnalysis/dealAnalysis";
import { default as DealDetailEdit } from "pages/dealSettings/dealEdit";
import { default as DealSettings } from "pages/dealSettings/dealSettings";
import { default as NewHedgeDetailPage } from "pages/hedgeDetail/hedgeDetail";
import { RefiAnalysisUnsupervised, RefiAnalysisSupervised } from 'pages/refiAnalysis';
import hedgeDetailEdit from "pages/hedgeDetail/hedgeDetailEdit";
import LenderReportsNoiSetup from "pages/lenderReporting/reportComponentsSetup/noiSetup";
import LenderReportsDscrSetup from "pages/lenderReporting/reportComponentsSetup/dscrSetup";
import LenderReportsDebtYieldSetup from "pages/lenderReporting/reportComponentsSetup/debtYieldSetup";
import LenderReportsPreview from "pages/lenderReporting/reportPreview";
import LenderReportingSetup from "pages/lenderReporting/reportingSetup";
import LenderReports from "pages/lenderReporting/dashboard";
import LenderReportDetails from "pages/lenderReporting/dashboard/reportDetails";
import NoiCalculationDashboard from "pages/lenderReporting/reportingComponents/noiCalculationDashboard/noiRegularCalculationDashboard/noiRegularCalculationDashboard";
import DscrCalculationDashboard from "pages/lenderReporting/reportingComponents/dscrCalculationDashboard/dscrRegularCalculationDashboard/dscrRegularCalculationDashboard";
import DebtYieldCalculationDashboard from "pages/lenderReporting/reportingComponents/debtYieldCalculationDashboard/debtYieldRegularCalculationDashboard/debtYieldRegularCalculationDashboard";
import LenderReportingDashboard from "pages/lenderReportingDashboard/lenderReportingDashboard";
import lenderReportingSubmittedReports from "pages/lenderReportingDashboard/lenderReportingSubmittedReports";
import { LenderReportingSettings } from 'pages/lenderReportingDashboard/settings'
import LenderReportingTasks from "pages/lenderReportingDashboard/lenderReportingTasks";
import LenderView from "pages/lenderReportingDashboard/lenderView/lenderView";
import SREOScreener from "pages/sreoScreener/SREOScreener";
import DealScreener from 'pages/dealScreener/dealScreener';
import { default as NewLoanDetailPage } from "pages/loanDetail/loanDetail";
import loanDetailEdit from "pages/loanDetail/loanDetailEdit";
import { default as NewPropertyDetailPage } from "pages/propertyDetail/propertyDetail";
import propertyDetailEdit from "pages/propertyDetail/propertyDetailEdit";
import { default as QuoteDetailPage } from "pages/quoteDetail/quoteDetail";
import quoteHistory from "pages/quoteHistory/quoteHistory";
import { EmailCampaignDashboard, MasterContactList, IndividualCampaign } from "pages/campaigns";
import EmailDraft from "pages/campaigns/EmailDraft";
import CampaignsTest from "pages/campaigns/demo/Demo";
import DebtValuationSetup from "pages/debtValuation/DebtValuationSetup";
import DebtValuationDashboard from "pages/debtValuation/DebtValuationDashboard";
import DebtValuationSpreadTable from "pages/debtValuation/DebtValuationSpreadTable";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import { Flip, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { checkAuth } from "store/state/auth";
import styled from "styled-components";
import "typeface-space-mono";
import "typeface-work-sans";
import "./App.css";
import SSOHandler from "./ssoHandler";
import ErrorPage from "./ErrorPage";
import Apps from "pages/apps/Apps"
import RefiBreakevenView from "pages/campaigns/templates/RefiBreakeven";
import RefiCashoutView from "pages/campaigns/templates/RefiCashout";
import Comm100Chat from "components/Comm100Chat";

import LenderReportsNoiProjectedSetup from "pages/lenderReporting/reportComponentsSetup/noiProjectedSetup";
import LenderReportsDscrProjectedSetup from "pages/lenderReporting/reportComponentsSetup/dscrProjectedSetup";
import LenderReportsDebtYieldProjectedSetup from "pages/lenderReporting/reportComponentsSetup/debtYieldProjectedSetup";
import DscrProjectedCalculationDashboard from "pages/lenderReporting/reportingComponents/dscrCalculationDashboard/dscrProjectedCalculationDashboard/dscrProjectedCalculationDashboard";
import NoiProjectedCalculationDashboard from "pages/lenderReporting/reportingComponents/noiCalculationDashboard/noiProjectedCalculationDashboard/noiProjectedCalculationDashboard";
import DebtYieldProjectedCalculationDashboard from "pages/lenderReporting/reportingComponents/debtYieldCalculationDashboard/debtYieldProjectedCalculationDashboard/debtYieldProjectedCalculationDashboard";
import OnboardingComponent from "pages/onboarding/onboarding";
numeral.register("format", "phone", {
  regexps: {
    format: /\+?N?[\.\ \-]?\(?NNN\)?[\.\ \-]?NNN[\.\ \-]?NNNN/
  },
  format(value, formatString) {
    function normalize(phoneNumber) {
      if (!phoneNumber) return 0;
      return phoneNumber.toString().replace(/^[\+\d{1,3}\-\s]*\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, "$1$2$3");
    }

    function format(phoneNumber, formatString) {
      phoneNumber = normalize(phoneNumber);
      for (let i = 0, l = phoneNumber.length; i < l; i++) {
        formatString = formatString.replace("N", phoneNumber[i]);
      }
      if (formatString.indexOf("N") > -1) {
        console.warn("invalid phone number", phoneNumber);
        return "--";
      }
      return formatString;
    }

    return format(value, formatString);
  }
});

const AppFlexContainer = styled.div`
  height: 100%;
  display: flex;
  flex-flow: column;
`;
const Spacer = styled.div`
  flex-grow: 1;
`;

export class App extends Component {
  state = {
    hasError: false,
    error: {},
    isInitial: true
  };

  componentDidMount() {
    this.props.checkAuth();
  }

  componentDidUpdate(prevProps) {
    const { authentication, datadogRum } = this.props;
    const { authentication: prevAuthentication } = prevProps;

    if (authentication.authed && !prevAuthentication.authed) {
      setTimeout(() => {
        this.setState({ isInitial: false });
      }, 2500);
      if (datadogRum) {
        const auth = authentication;
        const user = {
          contactId: auth.user.contact.id,
          id: auth.user.id
        };
        datadogRum.setUser(user);
      }
    }
  }

  componentDidCatch(error) {
    this.setState({ hasError: true, error });
  }

  getMainContentClass() {
    return this.props.authentication.isSystemAdmin ? "mainContentAdmin" : "mainContent";
  }

  us1876FeatureFlag = () =>
    this.props.flags[featureFlags.US1876_DEPRECATE_SISENSE_REPORTS];

  render() {
    const { authentication, history, loading } = this.props;
    const { hasError, error } = this.state;

    if (authentication?.user && !authentication?.user?.hasAcceptedAgreement && history?.location?.pathname !== POLICIES_AND_AGREEMENTS) {
      history.push(POLICIES_AND_AGREEMENTS);
    }
    return (
      <>
        <AppFlexContainer>
          <LoadingIndicator
            loading={
              loading.deal ||
              loading.users ||
              loading.authentication ||
              loading.funds ||
              loading.property ||
              loading.loan ||
              loading.avp ||
              loading.bankSwap ||
              loading.cashFlows ||
              loading.capPricer ||
              loading.redirect
            }
          >
            {authentication?.user?.hasAcceptedAgreement && <TopNavigation isHidden={!navBarShouldBeVisible(history?.location?.pathname)} />}
            {hasError && <ErrorPage error={error} />}
            <Notes />
            {!hasError && (
              <div className="mainContent" id="mainContent">
                <Switch>
                  <Route path="/" exact authentication={authentication} component={Home} />
                  <Route path={ROUTE_LOGIN} exact component={Login} />
                  <Route
                    path={ROUTE_ADMIN_LOGIN}
                    exact
                    component={
                      this.props.flags.red188AdminLoginPage === false
                        ? () => <Redirect to={ROUTE_LOGIN} />
                        : Login
                    }
                  />
                  <Route path={ROUTE_LOGOUT} exact component={Logout} />

                  <Route path={ROUTE_FORGOT_PASSWORD} exact component={ForgotPassword} />
                  <Route path={ROUTE_CHANGE_PASSWORD} exact component={ChangePassword} />
                  <Route path={POLICIES_AND_AGREEMENTS} exact component={PoliciesAndAgreements} />
                  <Route path={LENDER_REPORTING_LENDER_VIEW} exact component={LenderView} />

                  <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={ROUTE_APP_LANDING} Component={Reports} />

                  <PrivateRoute systemAdmin companyAdmin authentication={authentication} path={ROUTE_ADMIN} Component={Admin} />
                  <PrivateRoute systemAdmin companyAdmin user exact authentication={authentication} path={ROUTE_PORTFOLIO} Component={Portfolio} />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_PROPERTIES}
                    Component={Properties}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_FUNDS_DETAIL}
                    Component={FundDealsList}
                  />
                  <PrivateRoute systemAdmin companyAdmin user exact authentication={authentication} path={ROUTE_PIPELINE} Component={Pipeline} />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_NEW}
                    Component={NewPipelineDeal}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_PIPELINE_DEAD}
                    Component={Pipeline}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_PIPELINE_ACTIVE}
                    Component={Pipeline}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_PIPELINE_ACTIVE_DEAL}
                    Component={PipelineActiveDeal}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_PIPELINE_SOFT_QUOTES}
                    Component={Pipeline}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_PIPELINE_ARCHIVED}
                    Component={Pipeline}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEALS_DETAILS}
                    Component={Deal}
                  />
                  <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={ROUTE_CALCULATORS} Component={Calculators} />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    authentication={authentication}
                    path={ROUTE_USERS_CHANGE_PASS}
                    Component={ResetPass}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_LOAN_NEW}
                    Component={LoanDetailsPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_LOAN_VIEW}
                    Component={LoanDetailsPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_QUOTE_VIEW}
                    Component={NewLoan}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_LOAN_EDIT}
                    Component={LoanDetailsPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LOAN_DETAILS_PAGE}
                    Component={LoanDetailsPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={PIPELINE_DEAL_QUOTE_COMPARISON}
                    Component={QuoteComparison}
                  />
                  {this.us1876FeatureFlag() && <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={REPORTS} Component={Reports} />}
                  <PrivateRoute systemAdmin companyAdmin user authentication={authentication} path={NEW_REPORTS} Component={NewReports} />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    authentication={authentication}
                    path={HEDGE_ESCROWS_LEDGER}
                    Component={HedgeEscrowLedger}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    authentication={authentication}
                    path={HEDGE_DETAILS}
                    Component={HedgeDetailPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    authentication={authentication}
                    path={CASHFLOWS_PAGE}
                    Component={CashflowsPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    authentication={authentication}
                    path={NOTIFICATIONS_PAGE}
                    Component={Notifications}
                  />

                  <PrivateRoute allRoles authentication={authentication} path={ROUTE_GUEST_LANDING} Component={GuestLanding} />
                  <PrivateRoute allRoles authentication={authentication} path={ROUTE_GUEST_COMPANY_LANDING} Component={GuestCompanyLanding} />
                  <PrivateRoute allRoles authentication={authentication} path={ROUTE_DEAL_PROJECTIONS} Component={ProjectionsPage} />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DASHBOARD}
                    Component={Dashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_BROKER_DASHBOARD}
                    Component={BrokerDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_APPS}
                    Component={Apps}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_LITE}
                    Component={DealLite}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL}
                    Component={NewDeal}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS}
                    Component={LenderReports}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORT_DETAILS}
                    Component={LenderReportDetails}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_SETUP}
                    Component={LenderReportingSetup}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_NOI_SETUP}
                    Component={LenderReportsNoiSetup}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_PROJECTED_NOI_SETUP}
                    Component={LenderReportsNoiProjectedSetup}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_DSCR_SETUP}
                    Component={LenderReportsDscrSetup}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_PROJECTED_DSCR_SETUP}
                    Component={LenderReportsDscrProjectedSetup}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_DEBT_YIELD_SETUP}
                    Component={LenderReportsDebtYieldSetup}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_PROJECTED_DEBT_YIELD_SETUP}
                    Component={LenderReportsDebtYieldProjectedSetup}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_PREVIEW}
                    Component={LenderReportsPreview}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_COMPONENTS_NOI_CALC}
                    Component={NoiCalculationDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_NOI_CALC}
                    Component={NoiProjectedCalculationDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_COMPONENTS_DSCR_CALC}
                    Component={DscrCalculationDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_DSCR_CALC}
                    Component={DscrProjectedCalculationDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_COMPONENTS_DY_CALC}
                    Component={DebtYieldCalculationDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_LENDER_REPORTS_COMPONENTS_PROJECTED_DY_CALC}
                    Component={DebtYieldProjectedCalculationDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    guest
                    authentication={authentication}
                    path={ROUTE_PROPERTY_DETAIL}
                    Component={NewPropertyDetailPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    guest
                    authentication={authentication}
                    path={ROUTE_PROPERTY_DETAIL_EDIT}
                    Component={propertyDetailEdit}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    guest
                    authentication={authentication}
                    path={ROUTE_LOAN_DETAIL}
                    Component={NewLoanDetailPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    guest
                    authentication={authentication}
                    path={ROUTE_LOAN_DETAIL_EDIT}
                    Component={loanDetailEdit}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    guest
                    authentication={authentication}
                    path={ROUTE_HEDGE_DETAIL}
                    Component={NewHedgeDetailPage}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    guest
                    authentication={authentication}
                    path={ROUTE_HEDGE_DETAIL_EDIT}
                    Component={hedgeDetailEdit}
                  />

                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_QUOTE_DETAIL}
                    Component={QuoteDetailPage}
                  />
                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_QUOTES_BY_DEAL}
                    Component={QuoteDetailPage}
                  />
                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_ANALYSIS}
                    Component={DealAnalysis}
                  />
                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_REFI_PROCEEDS_ANALYSIS_UNSUPERVISED()}
                    Component={RefiAnalysisUnsupervised}
                  />
                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_REFI_PROCEEDS_ANALYSIS_SUPERVISED()}
                    Component={RefiAnalysisSupervised}
                  />

                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_QUOTE_HISTORY}
                    Component={quoteHistory}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_SETTINGS}
                    Component={DealSettings}
                  />
                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_DETAIL_EDIT}
                    Component={DealDetailEdit}
                  />

                  <PrivateRoute
                    companyAdmin
                    systemAdmin
                    user
                    guest
                    exact
                    authentication={authentication}
                    path={SREO_SCREENER}
                    Component={SREOScreener}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_SCREENER_EDC()}
                    Component={DealScreener}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={authentication}
                    path={ROUTE_DEAL_SCREENER}
                    Component={DealScreener}
                  />

                  <Route
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={ROUTE_CAMPAIGNS}
                    render={({ hide = true }) => <EmailCampaignDashboard hideNavBar={hide} />}
                  // component={EmailCampaignDashboard}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    exact
                    authentication={this.props.authentication}
                    path={ROUTE_EDC_MASTER_CONTACT_LIST}
                    Component={MasterContactList}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={ROUTE_INDIVIDUAL_CAMPAIGN}
                    Component={IndividualCampaign}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={ROUTE_EMAIL_DRAFT}
                    Component={EmailDraft}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={DEBT_VALUATION_SETUP}
                    Component={DebtValuationSetup}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={DEBT_VALUATION_DASHBOARD}
                    Component={DebtValuationDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={DEBT_VALUATION_SPREADS}
                    Component={DebtValuationSpreadTable}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={LENDER_REPORTING_DASHBOARD}
                    Component={LenderReportingDashboard}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={LENDER_REPORTING_SETTINGS}
                    Component={LenderReportingSettings}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={LENDER_REPORTING_TASK_VIEW}
                    Component={LenderReportingTasks}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={LENDER_REPORTING_SUBMITTED}
                    Component={lenderReportingSubmittedReports}
                  />
                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    exact
                    authentication={this.props.authentication}
                    path={'/campaigns-test'}
                    Component={CampaignsTest}
                  />

                  <PrivateRoute
                    systemAdmin
                    companyAdmin
                    user
                    guest
                    exact
                    authentication={this.props.authentication}
                    path={ROUTE_ONBOARDING_VIEW}
                    Component={OnboardingComponent}
                  />

                  <Route path={REFI_BREAKEVEN_VIEW} component={RefiBreakevenView} />
                  <Route path={PREPAYMENT_SNAPSHOT_VIEW} component={PrepaymentSnapshot} />
                  <Route path={VALUATION_SENSITIVITY_SNAPSHOT_VIEW} component={ValuationSensitivitySnapshot} />
                  <Route path={REFI_CASHOUT_VIEW} component={RefiCashoutView} />

                  <Route path="/sso" component={SSOHandler} />
                  <Route path="/AccessDenied" component={AccessDenied} />
                  <Route path="*" component={NoMatch} />
                </Switch>
              </div>
            )}
            <Spacer />
          </LoadingIndicator>
        </AppFlexContainer>
        <Comm100Chat />
        <ToastContainer closeButton={false} autoClose={2000} transition={Flip} />
      </>
    );
  }
}

const mapStateToProps = ({ authentication, loading }) => ({
  authentication,
  loading
});


export default compose(
  withRouter,
  withLDConsumer(),
  connect(mapStateToProps, { checkAuth })
)(App);

